import { api } from '@/libs/axios/axios'
import {
  getCustomPromptListQuery,
  createCustomPromptQuery,
  updateCustomPromptQuery,
  deactivateCustomPromptQuery,
  getSpecialtyMarkdownQuery,
  generateCustomMarkdownQuery,
} from './graphql'

export function useCustomizationApi() {
  const graphqlUrl = '/graphql'

  //get
  const getCustomPromptList = async ({ page, limit, search }) => {
    const input = {
      page: page || 1,
      limit: limit || 10,
      search: search || '',
    }
    const { data } = await api.post(graphqlUrl, {
      query: getCustomPromptListQuery,
      variables: {
        input,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.listCustomPrompts
  }

  // create
  const createCustomPrompt = async ({
    title,
    content,
    specialty,
    isActive,
    creationMethod,
  }) => {
    const input = {
      title,
      content,
      specialty,
      isActive,
      creationMethod,
    }
    const { data } = await api.post(graphqlUrl, {
      query: createCustomPromptQuery,
      variables: {
        input,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.createCustomPrompt
  }

  // update
  const updateCustomPrompt = async ({
    id,
    title,
    content,
    specialty,
    isActive,
  }) => {
    const input = {
      id,
    }
    title && (input.title = title)
    content && (input.content = content)
    specialty && (input.specialty = specialty)
    isActive && (input.isActive = isActive)
    const { data } = await api.post(graphqlUrl, {
      query: updateCustomPromptQuery,
      variables: {
        input,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.updateCustomPrompt
  }

  // delete
  const deactivateCustomPrompt = async ({ id }) => {
    const input = {
      id,
    }
    const { data } = await api.post(graphqlUrl, {
      query: deactivateCustomPromptQuery,
      variables: {
        input,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.deactivateCustomPrompt
  }

  // get specialty markdown
  const getSpecialtyMarkdown = async ({ specialty }) => {
    const { data } = await api.post(graphqlUrl, {
      query: getSpecialtyMarkdownQuery,
      variables: {
        input: specialty,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.getMarkdownOfSpecialtiesAvailable
  }

  const generateCustomMarkdown = async ({ instructions }) => {
    const { data } = await api.post(graphqlUrl, {
      query: generateCustomMarkdownQuery,
      variables: {
        input: instructions,
      },
    })
    if (data.errors?.length > 0) {
      throw new Error(data.errors[0].message)
    }
    return data.data.generateMarkdown
  }

  return {
    getCustomPromptList,
    createCustomPrompt,
    deactivateCustomPrompt,
    updateCustomPrompt,
    getSpecialtyMarkdown,
    generateCustomMarkdown,
  }
}
